import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const MissionSection = () => {
  const { translations } = useLanguage();
  const missionAreas = translations?.missionAreas || [];

  if (!missionAreas.length) return null;

  return (
    <section id="who-we-are" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Title */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1D1D1D] leading-tight">
            {translations?.missionTitle}{' '}
            <span className="bg-[#D4AF37] text-white px-3 py-1">
              {translations?.missionHighlight}
            </span>
          </h2>
          <p className="mt-6 text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            {translations?.missionDescription}
          </p>
        </div>

        {/* Three Columns */}
        <div className="grid md:grid-cols-3 gap-8 mt-12">
          {missionAreas.map((area, index) => (
            <div key={index} className="text-center">
              <h3 className="text-xl font-bold text-[#1D1D1D] mb-4">
                {area.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {area.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
